import locale from "@bonliva-crm/locale";
import { QualityCheck, QualityCheckProps } from "./quality-check";
import { useRequestSent } from "./use-request-sent";
import { QualityCheckButton } from "./quality-check-button";
import { LabelWithInfo } from "./label-with-info";

export function ProfessionCertQualityCheck(props: QualityCheckProps) {
  const { data, consultantData } = props;

  const { loading, onRequestSent } = useRequestSent({
    data,
    consultantData
  });

  if (data.Name !== "Yrkesbevis") {
    throw new Error("ProfessionCertQualityCheck can only be used for Yrkesbevis");
  }

  return (
    <QualityCheck
      {...props}
      renderExtraAction={() => (
        <QualityCheckButton
          text={locale.Order}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onRequestSent(false);
          }}
          disabled={loading || data.Disabled}
          loading={loading}
        />
      )}
      renderLabel={(label) => (
        <LabelWithInfo label={label} info={locale.hospQualityCheckInfo} />
      )}
    />
  );
}
